/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_ButtonInputs */

const en_support_button = /** @type {(inputs: Support_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support the Platform`)
};

const es_support_button = /** @type {(inputs: Support_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoyar la Plataforma`)
};

const fr_support_button = /** @type {(inputs: Support_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soutenir la plateforme`)
};

const de_support_button = /** @type {(inputs: Support_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Plattform unterstützen`)
};

const id_support_button = /** @type {(inputs: Support_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukung Platform`)
};

/** @type {(inputs: Support_ButtonInputs) => LocalizedString} */
const ja_support_button = en_support_button;

/** @type {(inputs: Support_ButtonInputs) => LocalizedString} */
const zh_support_button = en_support_button;

/** @type {(inputs: Support_ButtonInputs) => LocalizedString} */
const ar_support_button = en_support_button;

/** @type {(inputs: Support_ButtonInputs) => LocalizedString} */
const it_support_button = en_support_button;

/** @type {(inputs: Support_ButtonInputs) => LocalizedString} */
const ru_support_button = en_support_button;

/** @type {(inputs: Support_ButtonInputs) => LocalizedString} */
const pt_support_button = en_support_button;

/** @type {(inputs: Support_ButtonInputs) => LocalizedString} */
const ko_support_button = en_support_button;

/**
* | output |
* | --- |
* | "Support the Platform" |
*
* @param {Support_ButtonInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const support_button = /** @type {((inputs?: Support_ButtonInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_ButtonInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_support_button(inputs)
	if (locale === "es") return es_support_button(inputs)
	if (locale === "fr") return fr_support_button(inputs)
	if (locale === "de") return de_support_button(inputs)
	if (locale === "ja") return ja_support_button(inputs)
	if (locale === "zh") return zh_support_button(inputs)
	if (locale === "ar") return ar_support_button(inputs)
	if (locale === "id") return id_support_button(inputs)
	if (locale === "it") return it_support_button(inputs)
	if (locale === "ru") return ru_support_button(inputs)
	if (locale === "pt") return pt_support_button(inputs)
	return ko_support_button(inputs)
});